import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProductPageComponent } from './pages/product-page.component';
import { AddProductComponent } from './components/addProduct/add-product.component';
import { ProductQueryComponent } from './components/productQuery/product-query.component';
import { FilterPipe } from '../../pipes/filter.pipe';
import { QueryProductPageComponent } from './pages/query-product-page.component';
import { EditProductComponent } from './components/edit-product/edit-product.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { InputComponent } from '../shared/components/input/input.component';

@NgModule({
    declarations: [
        ProductPageComponent,
        QueryProductPageComponent,
        AddProductComponent,
        ProductQueryComponent,
        FilterPipe,
        EditProductComponent,
    ],
    exports: [ProductPageComponent],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        RouterModule,
        NgSelectModule,
        InputComponent,
    ],
})
export class ProductModule {}
